<template>
	<div class="resetear-pw">
		<div class="resetear-pw-container">
			<div class="resetear-pw-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="resetear-pw-form" v-if="!isErrorHash">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<h1>Cambiar contraseña</h1>
					<p>Indica tu nueva contraseña y repítela.</p>
					<div class="resetear-pw-errors" v-if="$store.state.erroresResetearPw.length">
						<ul>
							<li>{{ this.$store.state.erroresResetearPw[0].msg }}</li>
						</ul>
					</div>
					<form action="" @submit.prevent="resetearPassword" novalidate="true">
						<div class="input-group">
							<label for="password">Nueva contraseña</label>
							<input tabindex="1" :type="btnPasswordType" name="password" id="password" class="no-icon" v-model.trim="password">
						</div>
						<div class="input-group">
							<label for="repeatPassword">Repetir nueva contraseña</label>
							<div class="input-group-input">
								<input tabindex="2" :type="btnPasswordType" name="repeatPassword" id="repeatPassword" v-model.trim="repeatPassword" placeholder="">
								<button type="button" class="togglePassword no-icon" tabindex="-1" @click.prevent="togglePassword"><eye-icon class="password-show" v-if="!showPassword"></eye-icon><eye-off-icon class="password-hide" v-else></eye-off-icon></button>
							</div>
						</div>
						<div class="input-row">
							<VueLoadingButton type="submit" tabindex="3" aria-label="" :loading="isLoadingBoton">Cambiar contraseña</VueLoadingButton>
						</div>
						<div class="iniciar-sesion">
							<span>¿Recordaste tu contraseña?</span>
							<router-link :to="{name: 'login' }" tabindex="4">Iniciar sesión</router-link>
						</div>
					</form>
				</div>
				<div class="resetear-pw-form" v-else>
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<div class="resetear-pw-fallido-title">
						<h1>¡Error!</h1>
						<img src="../../assets/error.svg" alt="Error">
					</div>
					<p>Hubo un error en el proceso de cambio de contraseña. Quizás el link expiró o no es correcto. Intenta otra vez.</p>
					<router-link :to="{ name: 'olvide-password' }">Intentar de nuevo</router-link>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
	</div>


	<!-- <div class="resetear-pw">
		<div class="container">
			<div class="resetear-pw-container">
				<div class="resetear-pw-section" v-if="!isErrorHash">
					<h1>Cambiar contraseña</h1>
					<p>Indica tu nueva contraseña y repítela.</p>
					<div class="resetear-pw-errors" v-if="$store.state.erroresResetearPw.length">
						<ul>
							<li>{{ this.$store.state.erroresResetearPw[0].msg }}</li>
						</ul>
					</div>
					<form action="" @submit.prevent="resetearPassword" novalidate="true">
						<div class="input-group">
							<label for="password">Nueva contraseña</label>
							<input tabindex="2" :type="btnPasswordType" name="password" id="password" v-model.trim="password">
							<key-icon></key-icon>
						</div>
						<div class="input-group">
							<label for="password">Repetir nueva contraseña</label>
							<input tabindex="3" :type="btnPasswordType" name="repeatPassword" id="repeatPassword" v-model.trim="repeatPassword">
							<button type="button" class="togglePassword" tabindex="4" @click.prevent="togglePassword"><eye-icon class="password-show" v-if="!showPassword"></eye-icon><eye-off-icon class="password-hide" v-else></eye-off-icon></button>
							<key-icon></key-icon>
						</div>
						<div class="input-row">
							<div class="login-link">
								<router-link :to="{ name: 'login' }" tabindex="4"><log-in-icon></log-in-icon>Iniciar sesión</router-link>
							</div>
							<VueLoadingButton type="submit" aria-label="" :loading="isLoadingBoton">Cambiar contraseña</VueLoadingButton>
						</div>
					</form>
				</div>
				<div class="resetear-pw-section" v-else>
					<div class="resetear-pw-fallido-title">
						<h1>¡Error!</h1>
						<img src="../../assets/error.svg" alt="Error">
					</div>
					<p>Hubo un error en el proceso de cambio de contraseña. Quizás el link expiró o no es correcto. Intenta otra vez.</p>
					<router-link :to="{ name: 'olvide-password' }">Intentar de nuevo</router-link>
				</div>
				<div class="right-section">
					<video width="100%" height="auto" autoplay loop>
						<source src="../../assets/banderas.mp4" type="video/mp4" />
					</video>
				</div>				
			</div>
		</div>
	</div> -->
</template>

<script>
	import VueLoadingButton from 'vue-loading-button'
	import { EyeIcon, EyeOffIcon } from 'vue-feather-icons'
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'resetear-password',
		data() {
			return {
				password: '',
				repeatPassword: '',
				isLoadingBoton: false,
				btnPasswordType: 'password',
				showPassword: false,
				hashVerificacion: this.$route.params.hashVerificacion,
				isErrorHash: null
			}
		},
		components: {
			'auth-right': AuthRight,
			EyeIcon,
			EyeOffIcon,
			VueLoadingButton
		},
		methods: {
			resetearPassword() {
				this.isLoadingBoton = true;
				this.$store.commit('limpiarErroresResetearPw');

				if(!this.password){
					this.$store.commit('insertarErrorResetearPw', 'Ingresa una contraseña');
					this.isLoadingBoton = false;
				} else {
					if(this.password.length < 6){
						this.$store.commit('insertarErrorResetearPw', 'Contraseña debe contener al menos 6 caracteres');
						this.isLoadingBoton = false;
					} else {
						if(!this.repeatPassword){
							this.$store.commit('insertarErrorResetearPw', 'Repite la contraseña');
							this.isLoadingBoton = false;
						} else {
							if(this.repeatPassword !== this.password){
								this.$store.commit('insertarErrorResetearPw', 'Contraseñas no coinciden');
								this.isLoadingBoton = false;
							} else {
								this.$store.dispatch('resetearPassword', {
									hashVerificacion: this.hashVerificacion,
									password: this.password
								})
								.then(response => {
									this.isLoadingBoton = false;
									this.$router.push({ name: 'login' })
								})
								.catch(error => {
									this.$store.commit('insertarErrorResetearPw', 'Activación inválida. Debe realizar el proceso nuevamente.');
									this.isLoadingBoton = false;
								})
							}
						}
					}
				}
			},
			togglePassword() {
				if(this.btnPasswordType === 'password') {
					this.btnPasswordType = 'text'
					this.showPassword = true
				} else {
					this.btnPasswordType = 'password'
					this.showPassword = false
				}
			},
		},
		mounted(){
			// Redirijo a Nacional.uy
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;

			// if(this.hashVerificacion.length === 36) {
			// 	this.isErrorHash = false;
			// } else {
			// 	this.isErrorHash = true;
			// }
		}
	}
</script>

<style lang="scss">
	.spinner{
		top: calc(50% - 3px) !important;
	}

	.spinner span{
		border-width: 2px !important;
		border-color: #fff transparent transparent transparent !important;
	}
</style>

<style scoped lang="scss">
	@import '../../styles/typography.scss';
	@import '../../styles/mixins.scss';

	.resetear-pw{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.resetear-pw-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.resetear-pw-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.resetear-pw-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 450px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					.resetear-pw-fallido-title{
						margin-bottom: 10px;
						@include flex(row, flex-start, center);

						img{
							margin-left: 10px;
							margin-top: 12px;
							width: auto;
							height: 26px;
						}
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						color: #29355c;
						font-size: 14px;
					}

					.resetear-pw-errors{
						@include flex(row, flex-start, center);
						width: 100%;
						padding: 0;
						margin: 10px 0;

						ul{
							list-style: none;
							margin: 0;
							padding: 0;

							li{
								width: 100%;
								font-size: 13px;
								font-weight: 700;
								color: #c61431;
								line-height: 1.5em;
							}
						}
					}

					form{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.input-group{
							width: 100%;
							margin: 8px 0;
							position: relative;
							@include flex(column, flex-start, flex-start);

							.input-group-input{
								width: 100%;
								margin: 0;
								padding: 0;
								position: relative;

								svg{
									color: rgba(48, 62, 103, 0.5);
									width: 18px;
									height: 18px;
									position: absolute;
									top: 50%;
									left: 15px;
									transform: translateY(-50%);
								}
							}

							label{
								margin-bottom: 4px;
								font-weight: 600;
								color: #29355c;
								font-size: 13px;
							}

							input{
								width: 100%;
								outline: none;
								border: 1px solid #e6e6e6;
								border-radius: 4px;
								padding: 12px 14px 12px 42px;
								font-size: 13px;
								background-color: #fff;
								box-shadow: none;
								transition: all .2s;
								color: #29355c;
								@include sinApariencia();

								&:focus{
									background-color: #fff;
									border: 1px solid #007bff;
								}

								&.no-icon{
									padding-left: 14px;
								}

								&#repeatPassword{
									padding: 12px 42px 12px 14px;
								}
							}

							.togglePassword{
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
								right: 15px;
								left: auto;
								width: 18px;
								height: 18px;
								padding: 0;
								background-color: transparent;
								background: none;
								@include flex(row, center, center);

								svg{
									color: rgba(48, 62, 103, 0.5);
									margin: 0;
									width: 18px;
									height: 18px;
									stroke-width: 2px;
									top: inherit;
									left: inherit;
								}

								&:focus{
									svg{
										color: #007bff;	
									}
								}
							}
						}

						.input-row{
							margin: 10px 0;
							width: 100%;
							padding: 0;
							@include flex(row, space-between, center);
						}

						button{
							width: 100%;
							margin: 0;
							padding: 13px;
							background-color: #11244d;
							color: #fff;
							font-weight: 400;
							font-size: 12px;
							text-transform: uppercase;
							letter-spacing: 2px;
							outline: none;
							border: none;
							border-radius: 5px;
							cursor: pointer;
							transition: all .2s;

							&:hover{
								background-color: #c61431;
							}

							&:disabled{
								color: rgba(27, 46, 75, 0.9);
								background-color: #ddd;
								cursor: not-allowed;
							}
						}

						.login-link{
							@include flex(row, flex-start, center);

							a{
								color: #007bff;
								transition: all .2s;
								font-size: 14px;
								line-height: 1em;
								@include flex(row, center, center);

								&:focus{
									outline: none;
									opacity: 0.9;
								}
							}

							svg{
								width: 14px;
								height: 14px;
								margin-right: 5px;
								margin-bottom: 1px;
							}
						}

						.iniciar-sesion{
							width: 100%;
							@include flex(row, center, center);
							padding: 10px 0;

							span{
								font-weight: 300;
								font-size: 14px;
								margin-right: 3px;
							}

							a{
								font-weight: 500;
								font-size: 14px;
								margin-left: 3px;
							}
						}
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1360px){
		.resetear-pw{
			.resetear-pw-container{
				.resetear-pw-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.resetear-pw{
			.resetear-pw-container{
				.resetear-pw-left{
					width: 600px;
					
					.resetear-pw-form{
						max-width: 380px;
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.resetear-pw{
			.resetear-pw-container{
				.resetear-pw-left{
					width: 100%;
					
					.resetear-pw-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}
</style>